import accountingSoftware from './svgs/Accounting-Software.svg';
import flinks from './svgs/flinks.svg';
import globalPayments from './svgs/global-payments.svg';
import invertie from './svgs/Inverite.svg';
import ipAddress from './svgs/ip-address.svg';
import paylink from './svgs/paylink.svg';
import plaid from './svgs/plaid.svg';
import webhooks from './svgs/webhooks.svg';
import approvalSettings from './svgs/approval-settings.svg';
import brandSettings from './svgs/brand-settings.svg';
import domainSetup from './svgs/domain-setup.svg';
import preFunding from './svgs/pre-funding.svg';

export type SettingsCardImgs =
  | 'domainSetup'
  | 'accountingSoftware'
  | 'approvalSettings'
  | 'flinks'
  | 'globalPayments'
  | 'invertie'
  | 'ipAddress'
  | 'paylink'
  | 'plaid'
  | 'webhooks'
  | 'brandSettings'
  | 'preFunding';
export const SettingsCardImgsMap: { [key in SettingsCardImgs]: { src: string; alt: string } } = {
  domainSetup: {
    src: domainSetup,
    alt: 'domain setup',
  },
  accountingSoftware: {
    src: accountingSoftware,
    alt: 'Accounting Software',
  },
  approvalSettings: {
    src: approvalSettings,
    alt: 'Approval Settings',
  },
  brandSettings: {
    src: brandSettings,
    alt: 'Brand Settings',
  },
  flinks: {
    src: flinks,
    alt: 'Flinks',
  },
  globalPayments: {
    src: globalPayments,
    alt: 'Global Payments',
  },
  invertie: {
    src: invertie,
    alt: 'Invertie',
  },
  ipAddress: {
    src: ipAddress,
    alt: 'IP Address',
  },
  paylink: {
    src: paylink,
    alt: 'paylink',
  },
  plaid: {
    src: plaid,
    alt: 'Plaid',
  },
  webhooks: {
    src: webhooks,
    alt: 'Webhooks',
  },
  preFunding: {
    src: preFunding,
    alt: 'Pre-Funding Settings',
  },
};
